module.exports = __webpack_public_path__ + "img/ua.1ace0125.svg";